import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const CanvaBack = () => {
  const location = useLocation();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // Parse query parameters from the location object
    const queryParams = new URLSearchParams(location.search);
    const errorParam = queryParams.get('error');

    // Check if the error parameter is set to 12
    if (errorParam === '12') {
      setError('Your session has expired. Please go back to Canva and restart.');
    } else {
      setError(null);
    }
  }, [location.search]); // Re-run the effect if the search part of the URL changes

  return (
    <>
      <Helmet>
        <title>AI Music</title>
      </Helmet>

      <div className="text-center">
        {/* Header */}
        <div className="mb-6">
          <h1 className="text-slate-900 text-3xl font-semibold mb-2">
            AI Music
          </h1>
          <p className="text-slate-600">
            Powered by AI Music Technology
          </p>
        </div>

        {/* Error Alert */}
        {error && (
          <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-lg">
            <div className="flex items-start gap-3">
              <svg
                className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                  clipRule="evenodd"
                />
              </svg>
              <div className="flex-1 text-left">
                <p className="text-sm text-red-800 font-medium">Session Expired</p>
                <p className="text-sm text-red-700 mt-1">{error}</p>
              </div>
            </div>
          </div>
        )}

        {/* Back Button */}
        <button
          onClick={() => window.close()}
          className="w-full py-3 px-6 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors duration-200 font-medium"
        >
          Back to Canva
        </button>
      </div>
    </>
  );
};

export default CanvaBack;
